(function() {
  angular.module('cfn').controller('calendarFilterPopupController', [
    '$scope',
    '$rootScope',
    '$log',
    '$http',
    'dialog',
    '$dialog',
    'calendarController',
    'i18nFilter',
    function(
      $scope,
      $rootScope,
      $log,
      $http,
      dialog,
      $dialog,
      calendarController,
      i18nFilter
    ) {
      var initialFilter = angular.copy(calendarController.filter);
      $scope.filter = calendarController.filter;

      angular.forEach($scope.filter, function(v) {
        if (v.category == 'Common' && v.type == 'USER') {
          v['$cfngrid_hidden'] = true;
        }
      });

      enums.CalendarFilterEnum = {
        Common: i18n('fe.calendar.filter.enum.common', 'Allgemein'),
        Person: i18n('fe.calendar.filter.enum.person', 'Person'),
        Operationalbranch: i18n(
          'fe.calendar.filter.enum.operationalbranch',
          'Betriebszweig'
        ),
        Field: i18n('fe.calendar.filter.enum.field', 'Pflanzenbau'),
        options: ['Common', 'Person', 'Operationalbranch', 'Field'],
        translated: {},
        translatedOptions: [
          i18n('fe.calendar.filter.enum.common', 'Allgemein'),
          i18n('fe.calendar.filter.enum.person', 'Person'),
          i18n('fe.calendar.filter.enum.operationalbranch', 'Betriebszweig'),
          i18n('fe.calendar.filter.enum.field', 'Pflanzenbau')
        ]
      };

      enums.CalendarFilterEnum.translated[
        i18n('fe.calendar.filter.enum.common', 'Allgemein')
      ] =
        'Common';
      enums.CalendarFilterEnum.translated[
        i18n('fe.calendar.filter.enum.person', 'Person')
      ] =
        'Person';
      enums.CalendarFilterEnum.translated[
        i18n('fe.calendar.filter.enum.operationalbranch', 'Betriebszweig')
      ] =
        'Operationalbranch';
      enums.CalendarFilterEnum.translated[
        i18n('fe.calendar.filter.enum.field', 'Pflanzenbau')
      ] =
        'Field';

      $scope.close = function() {
        $scope.filter = initialFilter;
        calendarController.filter = $scope.filter;
        dialog.close({ action: 'cancelled' });
      };

      $scope.ok = function() {
        var filterList = [];
        $.each($scope.filter, function(k, v) {
          v['$cfngrid_hidden'] = undefined;
          filterList.push(v);
        });
        $rootScope.alertController.addTemporaryAlert(
          i18nFilter(
            'fe.calendar.filter.message.saved',
            'Filter aktualisiert.'
          ),
          'success'
        );
        calendarController.updateCalendar();
        dialog.close();
      };

      return ($scope.calendarFilterPopupController = this);
    }
  ]);
})();
